export default __webpack_public_path__ + "static/media/blocked_users.31044dbc.svg";